import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  GetAllProductsApi,
  GetSingleProductsApi,
} from "@/redux/api/product-processing-api/ProductProcessingApi";

// Async thunks for API calls
export const GetAllProducts = createAsyncThunk(
  "product/GetAllProducts",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await GetAllProductsApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const GetSingleProducts = createAsyncThunk(
  "product/GetSingleProducts",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await GetSingleProductsApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

// Initial state

const initialState = {
  loading: false,
  products: {},
  singleProduct: {},
};

// Slice definition
const ProductProcessingSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllProducts.pending, (state) => {
        state.loading = true;
        state.products = [];
      })
      .addCase(GetAllProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload.response;
      })
      .addCase(GetAllProducts.rejected, (state) => {
        state.loading = false;
        state.products = [];
      });

    builder
      .addCase(GetSingleProducts.pending, (state) => {
        state.loading = true;
        state.singleProduct = {};
      })
      .addCase(GetSingleProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.singleProduct = action.payload.response;
      })
      .addCase(GetSingleProducts.rejected, (state) => {
        state.loading = false;
        state.singleProduct = {};
      });
  },
});

export default ProductProcessingSlice.reducer;
